import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'

export const IconWrapper = styled.div`
  margin-top: ${rem(16)};
  padding-left: ${rem(16)};
  padding-right: ${rem(16)};
  width: 100%;

  ${mediaQueryUp.tablet} {
    width: 50%;
    margin-top: ${rem(32)};
}

  ${mediaQueryUp.desktop} {
    width: 25%;
  }
`

export const IconsGrid = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: stretch;
  margin-top: ${rem(32)};
  margin-left: ${rem(-16)};
  margin-right: ${rem(-16)};
`

export const BenefitCard = styled.div`
  display: flex;
  ${mediaQueryUp.tablet} {
    text-align: center;
    flex-direction: column;
  }
`

export const BenefitText = styled.div`
  margin-left: ${rem(16)};

  > * + * {
    margin-top: ${rem(4)};
  }

  ${mediaQueryUp.tablet} {
    margin-top: ${rem(12)};
    margin-left: 0;
    > * + * {
      margin-top: ${rem(12)};
    }
  }
`
